var React = require('react');

function IconB3PlayerBusy (props) {
    return React.createElement("svg",props,[React.createElement("style",{"type":"text/css","key":0},"\r\n\t.st0{opacity:0.8;fill:#FFFFFF;enable-background:new    ;}\r\n\t.st1{fill:#3C3C3B;}\r\n"),React.createElement("g",{"key":1},[React.createElement("circle",{"className":"st0","cx":"-273","cy":"397","r":"16","key":0}),React.createElement("path",{"className":"st1","d":"M-273,388c-3.7,0-6.8,2.2-8.2,5.3c-0.1,0.3,1.1,1,1.8,1c1.1-2.5,3.5-4.3,6.4-4.3c3.9,0,7,3.1,7,7\r\n\t\tc0,3.9-3.1,7-7,7c-2.7,0-5-1.5-6.1-3.7c-0.7,0-2,0.6-1.8,0.8c1.5,2.9,4.5,4.9,8,4.9c5,0,9-4,9-9C-264,392-268,388-273,388z","key":1})])]);
}

IconB3PlayerBusy.displayName = "IconB3PlayerBusy";

IconB3PlayerBusy.defaultProps = {"version":"1.1","x":"0px","y":"0px","viewBox":"-289 381 32 32","style":{"enableBackground":"new -289 381 32 32"},"xmlSpace":"preserve"};

module.exports = IconB3PlayerBusy;

IconB3PlayerBusy.default = IconB3PlayerBusy;
